import { SceneDraggable } from "GameObjects/StoryGame/SceneDraggable";
import { SceneSpine } from "GameObjects/StoryGame/SceneSpine";
import { TimelineLite } from "gsap";
import * as HLF from "html-living-framework";

export class DressupClothing extends SceneDraggable {
    cancelSelectionWhenAnotherDragStarts = true;
    private _worn: boolean = false;

    constructor(pData: {clickSFX: string}) {
        super();
        this._clickedSfx = pData.clickSFX;
    }

    public get worn(): boolean {
        return this._worn;
    }

    public Wear() {
        this.visible = false;
        this._worn = true;
        this.playClickedSFX();
    }

    public Enable() {
        this.interactive = true;
    }
}